import DevelopmentHero from "../components/development-hero"
import ProductPartners from "../../../../components/product-partners"
import CarouselSection from "../components/carousel-section"
import EmployeeCarousel from "../../../../components/carousels/employee-carousel"
import JoinUsForm from "../../../../components/forms/joinus-form"

const DevelopmentCenter = () => {
    return (
        <section className="development-center-wrapper">
            <DevelopmentHero />
            <CarouselSection />
            <EmployeeCarousel />
            <JoinUsForm />
            <ProductPartners />
        </section>
    )
}

export default DevelopmentCenter